class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.summary = this.mainDetailsToggle.querySelector('summary');
    this.content.hidden = !this.mainDetailsToggle.open;
    this.summary.setAttribute('aria-expanded', String(this.mainDetailsToggle.open));

    // Native summary toggling + iPad Safari compositing can leave a stale menu
    // above the homepage hero. Use one deterministic toggle path instead.
    this.summary.addEventListener('click', (event) => {
      event.preventDefault();
      const nextOpen = !this.mainDetailsToggle.open;
      if (nextOpen) {
        this.content.hidden = false;
        this.mainDetailsToggle.open = true;
      } else {
        this.mainDetailsToggle.open = false;
        this.content.hidden = true;
      }
      this.summary.setAttribute('aria-expanded', String(nextOpen));
      if (this.header) this.header.preventHide = nextOpen;
    });
  }

  onToggle() {
    if (!this.mainDetailsToggle.open) {
      this.content.hidden = true;
      this.content.getAnimations().forEach(animation => animation.cancel());
    } else {
      this.content.hidden = false;
    }
    if (this.header) this.header.preventHide = this.mainDetailsToggle.open;
    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') === '' && this.header) {
      document.documentElement.style.setProperty(
        '--header-bottom-position-desktop',
        `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
      );
    }
  }

  close() {
    super.close();
    this.content.hidden = true;
  }
}

customElements.define('header-menu', HeaderMenu);
